import { toast } from "react-toastify";
import { useAdminLeadControllerDelete } from "service";
import { queryKeyFn } from "service/api/estabrookContext";
import { useDialogStore } from "@/state/dialog-store";
import { queryClient } from "@/query-client";

interface UseDeleteLeadOptions {
  // Called after a successful delete — e.g. navigate away from the detail page.
  onDeleted?: () => void;
}

// Shared delete flow used by the leads list row and the lead detail page:
// confirmation dialog -> delete -> toast + list invalidation -> onDeleted.
const useDeleteLead = ({ onDeleted }: UseDeleteLeadOptions = {}) => {
  const { setDialog } = useDialogStore();

  const { mutate, isLoading } = useAdminLeadControllerDelete({
    onSuccess: () => {
      toast.success("Lead deleted successfully");
      queryClient.invalidateQueries(
        queryKeyFn({
          path: "/api/v1/admin/leads",
          operationId: "adminLeadControllerGetAll",
          variables: {},
        }),
      );
      onDeleted?.();
    },
  });

  const confirmDeleteLead = (leadId: string, fullName: string) => {
    setDialog({
      title: "Delete lead",
      description: `Are you sure you want to delete "${fullName}"? This action cannot be undone.`,
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm: async (onClose) => {
        mutate({ pathParams: { leadId } });
        onClose();
      },
    });
  };

  return { confirmDeleteLead, isDeleting: isLoading };
};

export default useDeleteLead;
